import { FlexRow } from '@epam/promo';

import { HighlightedText } from 'components/common';
import { MODAL_ACTION_TYPE } from '../BaseModal';
import { ModalBodyProps } from './ModalBody.model';
import css from './ModalBody.module.scss';

const ModalBody = ({ text, highlights, bot, botImg }: ModalBodyProps) => (
  <>
    <img
      alt={bot === MODAL_ACTION_TYPE.CONFIRM ? 'confirm bot' : 'delete bot'}
      className={css.modal__pic}
      src={botImg}
    />
    <FlexRow
      cx={
        bot === MODAL_ACTION_TYPE.SAVE
          ? css['modal__description--save']
          : css.modal__description
      }>
      <HighlightedText highlights={highlights} text={text} />
    </FlexRow>
  </>
);

export { ModalBody };
